export const CONFIG_STATE = 'config'
export const SET_CONFIG = 'SET_CONFIG'
export const SET_PAGE = 'SET_PAGE'
